<template>
  <div class="zsszkb-container">
    <el-row>
      <el-col :span="16">
        <el-row class="tcf-row">
          <el-col style="margin-bottom: 20px;">
            <el-row class="today-box">
              <el-col :span="6" class="today-item">
                <div class="today-data">
                  <div class="icon"><i class="el-icon-s-custom"></i></div>
                  <div class="tit">今日新增</div>
                  <div class="num">{{todayData.add}}<span>位</span></div>
                </div>
              </el-col>
              <el-col :span="6" class="today-item">
                <div class="today-data">
                  <div class="icon"><i class="el-icon-s-claim"></i></div>
                  <div class="tit">今日转意向</div>
                  <div class="num">{{todayData.inten}}<span>位</span></div>
                </div>
              </el-col>
              <el-col :span="6" class="today-item">
                <div class="today-data">
                  <div class="icon"><i class="el-icon-s-check"></i></div>
                  <div class="tit">今日签约</div>
                  <div class="num">{{todayData.signup}}<span>位</span></div>
                </div>
              </el-col>
              <el-col :span="6" class="today-item">
                <div class="today-data">
                  <div class="icon"><i class="el-icon-s-finance"></i></div>
                  <div class="tit">今日回款</div>
                  <div class="num">{{formatMoney(todayData.payback,2,'.',',')}}<span>元</span></div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col class="card" style="margin-bottom: 20px">
            <div class="card-body">
              <div class="card-title">
                数据简报
                <el-date-picker
                  style="float: right;width: 250px;margin-top: -3px"
                  v-model="sjjbtime"
                  size="mini"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  @change="getDataBriefing"
                  type="daterange">
                </el-date-picker>
              </div>
              <div class="card-content" v-loading="dataBriefingLoading">
                <div class="state-box">
                  <div class="state-list">
                    <div class="state-item">
                      <div class="state-class">
                        <div class="state-title" @click="viewClientList(0)">新增客户 <i class="el-icon-warning-outline"></i></div>
                        <div class="state-data">{{dataBriefing.add}}</div>
                      </div>
                    </div>
                    <div class="state-item">
                      <div class="state-class">
                        <div class="state-title" @click="viewClientList(1)">转意向 <i class="el-icon-warning-outline"></i></div>
                        <div class="state-data">{{ dataBriefing.changeintent }}</div>
                      </div>
                      <div class="state-class">
                        <div class="state-title" @click="viewClientList(3)">意向客户 <i class="el-icon-warning-outline"></i></div>
                        <div class="state-data">{{dataBriefing.inten}}</div>
                      </div>
                    </div>
                    <div class="state-item">
                      <div class="state-class">
                        <div class="state-title" @click="viewClientList(2)">转合同 <i class="el-icon-warning-outline"></i></div>
                        <div class="state-data">{{dataBriefing.changesign}}</div>
                      </div>
                      <div class="state-class">
                        <div class="state-title" @click="viewClientList(4)">已签约 / 回款 <i class="el-icon-warning-outline"></i></div>
                        <div class="state-data">{{dataBriefing.signup}} / {{dataBriefing.payback}}</div>
                      </div>
                      <div class="state-class">
                        <div class="state-title" @click="viewClientList(5)">回款金额 <i class="el-icon-warning-outline"></i></div>
                        <div class="state-data">¥{{formatMoney(dataBriefing.paybackmoney,2,'.',',')}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="state-pic">
                    <div class="pic" :style="`background-image: url(${conversion_rates});`"></div>
                  </div>
                  <div class="growth"><div class="growth-title">意向转化率</div><span class="percentage">{{dataBriefing.intentrates}}%</span></div>
                  <div class="growth fk"><div class="growth-title">签约转化率</div><span class="percentage">{{dataBriefing.signrates}}%</span></div>
                  <div class="growth cj"><div class="growth-title">成交转化率</div><span class="percentage">{{dataBriefing.makerates}}%</span></div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col class="card" style="margin-bottom: 20px">
            <div class="card-body">
              <div class="card-title">
                <el-button-group>
                  <el-button :type="qsType===0?'primary':''" size="mini" @click="changeQs(0)">客户趋势</el-button>
                  <el-button :type="qsType===1?'primary':''" size="mini" @click="changeQs(1)">客户对比</el-button>
                </el-button-group>
                <el-date-picker
                  style="float: right;width: 245px;"
                  v-model="khsjfxtime"
                  :key="khsjfxKey"
                  size="mini"
                  @change="getQsData"
                  :format="khsjfxFormat"
                  :value-format="khsjfxValueFormat"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  :type="khsjfxType">
                </el-date-picker>
                <el-button-group v-if="qsType===0" style="float: right;margin-right: 5px">
                  <el-button :type="qsDateType===1?'primary':''" size="mini" @click="changeQsDateType(1)">按日</el-button>
                  <el-button :type="qsDateType===0?'primary':''" size="mini" @click="changeQsDateType(0)">按月</el-button>
                </el-button-group>
                <el-button-group v-if="qsType===1" style="float: right;margin-right: 5px">
                  <el-button :type="dbType===0?'primary':''" size="mini" @click="changeDbType(0)">新增</el-button>
                  <el-button :type="dbType===1?'primary':''" size="mini" @click="changeDbType(1)">意向</el-button>
                  <el-button :type="dbType===2?'primary':''" size="mini" @click="changeDbType(2)">签约</el-button>
                </el-button-group>
              </div>
              <div class="card-content" v-loading="dataAnalysisLoading">
                <div id="khsjfxChart" style="height: 300px;"></div>
              </div>
            </div>
          </el-col>
          <el-col class="card">
            <div class="card-body">
              <div class="card-title">
                客户来源
                <el-date-picker
                  style="float: right;width: 245px;margin-top: -3px"
                  v-model="khlytime"
                  @change="getClientSource"
                  size="mini"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="false"
                  type="daterange">
                </el-date-picker>
              </div>
              <div class="card-content" v-loading="sourceAnalysisLoading">
                <div id="clientSource" style="height: 300px;"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8">
        <el-row class="tcf-row" style="padding-left: 0">
          <el-col class="card">
            <div class="card-body">
              <div class="card-title">
                最新动态
                <el-button type="text" class="right" style="margin-top: 4px" @click="viewDynamic">查看更多</el-button>
              </div>
              <div class="card-content follow-list" v-loading="dynamicLoading">
                <div class="follow-item" v-for="d in newdynamiclst">
                  <div class="user-info">
                    <el-avatar class="photo" shape="square" :size="40" :src="d.photo" @click.native="viewUserInfo(d.userid)"></el-avatar>
                    <div class="name" @click="viewUserInfo(d.userid)">{{d.name}}<el-tag size="mini" :type="d.way==='客户录入'?'':d.way==='回归公海'?'danger':'warning'">{{d.way}}</el-tag></div>
                    <div class="time">{{d.time}}</div>
                  </div>
                  <div class="follow-content">
                    <span v-if="d.content!==null&&d.content!==undefined&&d.content!==''">{{d.content}}</span>
                    <span v-if="(d.content===null||d.content===undefined||d.content==='')&&d.imgurls.length>0">上传了{{d.imgurls.length}}张图片</span>
                  </div>
                  <div class="client-info" @click="openClientDetails(d.cid)">
                    <i class="el-icon-s-custom"></i> {{d.clientname}}<el-divider direction="vertical"></el-divider>{{d.markstr}}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-row class="tcf-row" style="padding-top: 0">
          <el-col class="card">
            <div class="card-body">
              <el-form :inline="true" size="small"  @submit.native.prevent>
                <el-form-item>
                  <div class="card-title">
                    市场调研
                  </div>
                </el-form-item>
                <el-form-item style="float: right">
                  <el-button type="primary" size="small" @click="editRow(null)" icon="el-icon-plus">添加调研</el-button>
                </el-form-item>
              </el-form>
              <div class="card-content" v-loading="mrloading">
                <el-table
                  :data="marketResearchData"
                  stripe
                  style="width: 100%;margin-bottom: 20px"
                  @row-click="openDetails">
                  <el-table-column
                    align="center"
                    label="城市"
                    width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope" >
                      <div>{{scope.row.province}}/{{scope.row.city}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="name"
                    label="调研人"
                    width="80"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="调研时间"
                    width="180"
                    show-overflow-tooltip>
                    <template slot-scope="scope" >
                      <div>{{scope.row.startdate}} - {{scope.row.enddate}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="time"
                    label="提交日期"
                    width="160"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="market"
                    label="市场情况"
                    min-width="160"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="180"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" @click.stop="editRow(scope.row)" size="mini">编辑</el-button>
                      <el-button icon="el-icon-delete" @click.stop="delRow(scope.row)" size="mini">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="mrtotal>0"
                  background
                  @size-change="mrhandleSizeChange"
                  @current-change="mrhandleCurrentChange"
                  :current-page="mrcurrentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="mrpageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mrtotal">
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="24">
        <el-row class="tcf-row" style="padding-top: 0">
          <el-col class="card">
            <div class="card-body">
              <div class="card-title">
                团队管理
              </div>
              <div class="card-content" v-loading="teamloading">
                <el-table
                  :data="teamlst"
                  stripe
                  :default-sort = "{prop: 'signcount', order: 'descending'}"
                  style="width: 100%;">
                  <el-table-column
                    type="index"
                    label="#"
                    width="60">
                  </el-table-column>
                  <el-table-column
                    label="头像"
                    width="80"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-avatar :size="30" :src="scope.row.photo" style="display: block;"></el-avatar>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名"
                    width="80"
                    show-overflow-tooltip>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    prop="sex"-->
<!--                    label="性别"-->
<!--                    width="60"-->
<!--                    show-overflow-tooltip>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column-->
<!--                    prop="dept"-->
<!--                    label="所属部门"-->
<!--                    width="100"-->
<!--                    show-overflow-tooltip>-->
<!--                  </el-table-column>-->
                  <el-table-column
                    prop="addcount"
                    label="新增"
                    width="80"
                    sortable
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="intentcount"
                    label="意向"
                    width="80"
                    sortable
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="signcount"
                    label="签约"
                    width="80"
                    sortable
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="意向转化率"
                    width="110"
                    prop="intentrate"
                    sortable
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.intentrate}}%
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签约转化率"
                    width="110"
                    prop="signrate"
                    sortable
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.signrate}}%
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="成交转化率"
                    min-width="110"
                    prop="makerate"
                    sortable
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{scope.row.makerate}}%
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="数字名片"
                    width="100"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.iscard===0" style="color: #F56C6C">未设置</span>
                      <el-popover
                        v-if="scope.row.iscard===1"
                        placement="top"
                        width="174"
                        trigger="click">
                        <div style="text-align: center">
                          <el-image :src="smallProgramCode!==null&&smallProgramCode!==undefined&&smallProgramCode!==''?smallProgramCode:qcode_loading" style="height: 150px;width: 150px"></el-image>
                        </div>
                        <span slot="reference" @click="getSmallProgramCode(scope.row.userid)" style="color: #409EFF;cursor: pointer">查看 <svg-icon style="width: 14px;height: 14px;vertical-align: -3px;color:#409EFF" icon-class="wxapplets" /></span>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="80"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope" >
                      <el-tag type="info" v-if="scope.row.mark===4" :disable-transitions="true" size="mini">离职</el-tag>
                      <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini">正常</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button icon="el-icon-document" size="mini" @click="viewUserInfo(scope.row.userid)">详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :title="clientlistType===1?'转意向列表':clientlistType===2?'转合同列表':clientlistType===3?'意向客户列表':clientlistType===4?'已签约/回款列表':clientlistType===5?'回款金额列表':'新增客户列表'"
      :visible.sync="clientVisible"
      width="80%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-table
        :data="clientData"
        v-loading="clientLoading"
        :key="clientTableKey"
        stripe
        style="width: 100%;margin-bottom: 20px">
        <el-table-column
          label="客户姓名"
          width="100"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <el-button size="mini" type="text" @click="openClientDetails(scope.row.cid)">{{scope.row.name}}</el-button>
            <svg-icon icon-class="client_man" style="width: 16px;height: 16px;vertical-align: -4px" v-if="scope.row.sex === 1"/>
            <svg-icon icon-class="client_women" style="width: 16px;height: 16px;vertical-align: -4px" v-if="scope.row.sex === 0" />
          </template>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===0"
          label="新增人"
          prop="createname"
          width="90"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===0"
          label="新增时间"
          prop="createtime"
          width="160"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===1||clientlistType===3"
          label="负责人"
          prop="followname"
          width="90"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===1||clientlistType===3"
          label="转意向时间"
          prop="intentime"
          width="160"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===2||clientlistType===4"
          label="签订人"
          prop="signname"
          width="90"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===2||clientlistType===4"
          label="签订日期"
          prop="signtime"
          width="120"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===5"
          label="回款人"
          prop="payname"
          width="90"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===5"
          label="回款日期"
          prop="paytime"
          width="120"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===5"
          label="回款金额"
          width="120"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <span style="font-weight: 500;color: #409EFF"><i class="el-icon-coin"></i> {{scope.row.paymoney}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===5"
          label="样品预存款"
          width="120"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <span><i class="el-icon-coin"></i> {{scope.row.payjoin}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===5"
          label="加盟费"
          width="120"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <span><i class="el-icon-coin"></i> {{scope.row.payinsure}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="客户状态"
          width="100"
          v-if="clientlistType!==5"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <el-tag type="info" :disable-transitions="true" size="mini" v-if="scope.row.mark===0&&clientlistType!==4">置入死海</el-tag>
            <el-tag type="danger" :disable-transitions="true" size="mini" v-if="scope.row.mark===1&&clientlistType!==4">回归公海</el-tag>
            <el-tag type="warning" :disable-transitions="true" size="mini" v-if="scope.row.mark===2 && scope.row.groupid!=4&&clientlistType!==4">跟进中</el-tag>
            <el-tag type="success" :disable-transitions="true" size="mini" v-if="scope.row.mark===2 && scope.row.groupid==4&&clientlistType!==4">已转意向</el-tag>
            <el-tag size="mini" :disable-transitions="true" v-if="scope.row.mark===3&&clientlistType!==4" class="tcf-tag-4">待打款</el-tag>
            <el-tag size="mini" :disable-transitions="true" v-if="scope.row.mark===9&&clientlistType!==4">已完成</el-tag>
            <el-tag type="danger" :disable-transitions="true" size="mini" v-if="scope.row.signmark!==2&&clientlistType===4">未回款</el-tag>
            <el-tag size="mini" :disable-transitions="true" v-if="scope.row.signmark===2&&clientlistType===4">已回款</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="客户等级"
          width="90"
          v-if="clientlistType!==5"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <span style="color:rgb(255, 153, 0)"><i class="el-icon-star-on"></i> {{scope.row.level}}.0</span>
          </template>
        </el-table-column>
        <el-table-column
          label="电话"
          prop="tel"
          width="120"
          v-if="clientlistType!==5"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="所在地区"
          width="160"
          v-if="clientlistType!==5"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            {{scope.row.province}} {{scope.row.city}} {{scope.row.county}}
          </template>
        </el-table-column>
        <el-table-column
          label="客户来源"
          width="120"
          v-if="clientlistType!==5"
          show-overflow-tooltip>
          <template slot-scope="scope" >
            <span>{{scope.row.source===1?'第三方平台':scope.row.source===2?'招商会':scope.row.source===3?'异业介绍':scope.row.source===4?'地推':scope.row.source===5?'商场推荐':scope.row.source===6?'数字名片':'其他'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="回款卡号"
          prop="paycard"
          width="120"
          v-if="clientlistType===5"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          v-if="clientlistType!==5"
          min-width="120"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          v-if="clientlistType===5"
          label="回款备注"
          prop="payremark"
          min-width="120"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="clientTotal>0"
        background
        @size-change="handleSizeChangeClient"
        @current-change="handleCurrentChangeClient"
        :current-page="clientCurrentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="clientPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="clientTotal">
      </el-pagination>
    </el-dialog>
    <el-dialog
      :visible.sync="viewVisible"
      title="客户档案"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      custom-class="khgl-client-detail"
      :append-to-body="true">
      <div class="view-box" v-loading="viewLoading">
        <el-steps :active="clientDetail.mark===2&&clientDetail.groupid===4?2:clientDetail.mark===3?3:clientDetail.mark===9?4:1" simple>
          <el-step title="客户录入" icon="el-icon-edit-outline"></el-step>
          <el-step title="转意向" icon="el-icon-refresh"></el-step>
          <el-step title="合同签订" icon="el-icon-document-checked"></el-step>
          <el-step title="打款" icon="el-icon-coin"></el-step>
          <el-step title="建店" icon="el-icon-office-building"></el-step>
        </el-steps>
        <el-row style="margin-top: 20px">
          <el-col :span="8">
            <el-card class="base-info" shadow="never">
              <div slot="header" class="tit">
                <span>基本资料</span>
              </div>
              <div class="text">
                <div class="l">
                  <span class="label">客户姓名:</span>
                  <span class="name">{{clientDetail.name}}</span>
                  <svg-icon icon-class="client_man" class="client-sex" v-if="clientDetail.sex === 1"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="clientDetail.sex === 0" />
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户等级:</span>
                  <el-rate style="float: left" v-model="clientDetail.level" disabled-void-color="#ffffff" disabled></el-rate>
                </div>
                <div class="l">
                  <span style="float: left" class="label">联系电话:</span>
                  <span>{{clientDetail.tel}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户微信:</span>
                  <span>{{clientDetail.wchat!==null&&clientDetail.wchat!==undefined&&clientDetail.wchat!==''?clientDetail.wchat:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">所在地区:</span>
                  <span>{{clientDetail.province}} {{clientDetail.city}} {{clientDetail.county}}</span>
                </div>
                <el-alert v-if="clientDetail.areadealerlst.length<=0&&clientDetail.mark===2" title="该区域目前还未有代理经销商" type="success" :closable="false" style="margin-bottom: 15px" show-icon></el-alert>
                <el-popover
                  v-if="clientDetail.areadealerlst.length>0"
                  placement="right"
                  width="420"
                  :key="areaKey"
                  trigger="hover">
                  <el-table :data="clientDetail.areadealerlst">
                    <el-table-column width="120" property="allname" label="经销商" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" label="代理品牌" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span v-for="(b,index) in scope.row.brandlst">{{b.brandname}}{{index===scope.row.brandlst.length-1?'':'、'}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column min-width="100" label="所在地区" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{scope.row.province}} {{scope.row.city}} {{scope.row.county}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-alert slot="reference" :title="`该区域目前已有${clientDetail.areadealerlst.length}个代理经销商`" type="warning" :closable="false" style="margin-bottom: 15px;cursor: pointer" show-icon></el-alert>
                </el-popover>
                <div class="l">
                  <span style="float: left" class="label">线下门店:</span>
                  <span>{{clientDetail.shop!==null&&clientDetail.shop!==undefined&&clientDetail.shop!==''?clientDetail.shop:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">门店面积:</span>
                  <span>{{clientDetail.area!==null&&clientDetail.area!==undefined&&clientDetail.area!==''&&clientDetail.area>0?clientDetail.area+' m²':'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户来源:</span>
                  <span>{{clientDetail.source===1?'第三方平台':clientDetail.source===2?'招商会':clientDetail.source===3?'异业介绍':clientDetail.source===4?'地推':clientDetail.source===5?'商场推荐':clientDetail.source===6?'数字名片':'其他'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户状态:</span>
                  <el-tag type="danger" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle==1 && clientDetail.mark===2&& clientDetail.refund!==1">即将回收</el-tag>
                  <el-tag type="info" :disable-transitions="true" size="mini" v-if="clientDetail.mark===0&& clientDetail.refund!==1">置入死海</el-tag>
                  <el-tag type="danger" :disable-transitions="true" size="mini" v-if="clientDetail.mark===1&& clientDetail.refund!==1">回归公海</el-tag>
                  <el-tag type="warning" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle!=1 && clientDetail.mark===2 && clientDetail.groupid!=4&& clientDetail.refund!==1">待跟进</el-tag>
                  <el-tag type="success" :disable-transitions="true" size="mini" v-if="clientDetail.is_recycle!=1 && clientDetail.mark===2 && clientDetail.groupid==4&& clientDetail.refund!==1">已转意向</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&clientDetail.paymark===10&& clientDetail.refund!==1" class="tcf-tag-8">待打款</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&(clientDetail.paymark===0||clientDetail.paymark===1)&& clientDetail.refund!==1" class="tcf-tag-4">收款审核中</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===3&&(clientDetail.paymark===3||clientDetail.paymark===4)&& clientDetail.refund!==1" type="danger">收款审核拒绝</el-tag>
                  <el-tag size="mini" :disable-transitions="true" v-if="clientDetail.mark===9&& clientDetail.refund!==1">已完成</el-tag>
                  <el-tag size="mini" :disable-transitions="true" type="info" v-if="clientDetail.refund===1">已退款</el-tag>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户备注:</span>
                  <span>{{clientDetail.remark!==null&&clientDetail.remark!==undefined&&clientDetail.remark!==''?clientDetail.remark:'N/A'}}</span>
                </div>
              </div>
            </el-card>
            <el-card shadow="never" class="principal" v-if="clientDetail.followname!==null&&clientDetail.followname!==undefined&&clientDetail.followname!==''">
              <div slot="header" class="tit">
                <span>负责人</span>
              </div>
              <el-row>
                <el-col :span="14" class="user-info" style="line-height: 36px">
                  <el-avatar size="medium" :src="clientDetail.followphoto" style="float: left;margin-right: 10px"></el-avatar>
                  <span>{{clientDetail.followname}}</span>
                </el-col>
                <el-col :span="10" style="text-align: right;line-height: 36px">
                  <el-dropdown trigger="click" v-if="clientDetail.mark===2" placement="top" :key="forwardKey">
                    <el-button size="mini">移交 <i class="el-icon-caret-top"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="u in clientDetail.forwardlist" v-if="clientDetail.followid!==u.dUserid" @click.native="forwardC(u)"><el-avatar :src="u.photourl" style="margin-right: 8px;width: 22px;height: 22px;line-height: 22px;float: left;margin-top: 7px"></el-avatar>{{u.dName}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="16" style="padding-left: 20px">
            <el-tabs v-model="activeViewName" :key="detailKey">
              <el-tab-pane label="跟进记录" name="gjjl"></el-tab-pane>
              <el-tab-pane label="转意向" name="yxj"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark>=3" label="合同档案" name="htda"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark===9" label="代理信息" name="dlxx"></el-tab-pane>
              <el-tab-pane v-if="clientDetail.mark===9" label="建店详情" name="jdxq"></el-tab-pane>
            </el-tabs>
            <div v-if="activeViewName === 'gjjl'">
              <div class="follow-list" v-loading="followLoading">
                <div class="follow-item" v-for="f in followList">
                  <div  class="follow-userinfo" v-if="f.username===null||f.username===undefined||f.username===''">
                    <el-avatar class="photo" shape="square" :size="50" :src="elichain_photo"></el-avatar>
                    <div class="name">慕鹿助手<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                    <div class="time">{{f.time}}</div>
                  </div>
                  <div class="follow-userinfo" v-if="f.username!==null&&f.username!==undefined&&f.username!==''">
                    <el-avatar class="photo" shape="square" :size="50" :src="f.photourl"></el-avatar>
                    <div class="name">{{f.username}}<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                    <div class="time">{{f.time}}</div>
                  </div>
                  <div class="follow-content" v-if="f.content!==null&&f.content!==undefined&&f.content!==''">{{f.content}}</div>
                  <div class="follow-imgs" v-if="f.imgurlarr.length>0">
                    <el-image
                      v-for="img in f.imgurlarr"
                      fit="cover"
                      class="follow-img"
                      :src="img"
                      :preview-src-list="f.imgurlarr"
                    />
                  </div>
                </div>
<!--                <div class="follow-item">-->
<!--                  <div class="follow-userinfo">-->
<!--                    <el-avatar class="photo" shape="square" :size="50" :src="clientDetail.createphoto"></el-avatar>-->
<!--                    <div class="name">{{clientDetail.createname}}<el-tag size="mini">客户录入</el-tag></div>-->
<!--                    <div class="time">{{clientDetail.createtime}}</div>-->
<!--                  </div>-->
<!--                  <div class="follow-content">-->
<!--                    由&nbsp;<span style="color: #409EFF">{{clientDetail.createdept}}-{{clientDetail.createname}}</span>&nbsp;录入此客户-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
            <div v-if="activeViewName === 'yxj'">
              <el-card shadow="never" class="base-info" v-if="clientDetail.clientInmon!==null&&clientDetail.clientInmon!==undefined&&clientDetail.clientInmon!==''">
                <div slot="header" class="tit">
                  <span>意向金确认单</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">加盟地区:</span>
                    <span>{{clientDetail.clientInmon.province}} - {{clientDetail.clientInmon.city}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">意向品牌:</span>
                    <span><el-tag size="mini" :disable-transitions="true" style="margin-right: 10px" effect="plain">{{clientDetail.clientInmon.brandname}}</el-tag></span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">意向金额:</span>
                    <span>{{clientDetail.clientInmon.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款卡号:</span>
                    <span>{{clientDetail.clientInmon.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款日期:</span>
                    <span>{{clientDetail.clientInmon.receipttime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款账户:</span>
                    <span>{{ clientDetail.clientInmon.accname }}（{{clientDetail.clientInmon.acccard}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">享受权限:</span>
                    <span>{{clientDetail.clientInmon.enjoy!==null&&clientDetail.clientInmon.enjoy!==undefined&&clientDetail.clientInmon.enjoy!==''?clientDetail.clientInmon.enjoy:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">填写备注:</span>
                    <span>{{clientDetail.clientInmon.remark!==null&&clientDetail.clientInmon.remark!==undefined&&clientDetail.clientInmon.remark!==''?clientDetail.clientInmon.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款凭证:</span>
                    <el-image v-for="iurl in yxjpayImgs"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="yxjpayImgs">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" style="margin-top: 20px" class="base-info" v-if="clientDetail.yxjtk!==null">
                <div slot="header" class="tit">
                  <span>意向金退款</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">收款人:</span>
                    <span>{{clientDetail.yxjtk.name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">开户行:</span>
                    <span>{{clientDetail.yxjtk.bank}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款金额:</span>
                    <span>{{clientDetail.yxjtk.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款卡号:</span>
                    <span>{{clientDetail.yxjtk.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款原因:</span>
                    <span>{{clientDetail.yxjtk.refundrson!==null&&clientDetail.yxjtk.refundrson!==undefined&&clientDetail.yxjtk.refundrson!==''?clientDetail.yxjtk.refundrson:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款备注:</span>
                    <span>{{clientDetail.yxjtk.remark!==null&&clientDetail.yxjtk.remark!==undefined&&clientDetail.yxjtk.remark!==''?clientDetail.yxjtk.remark:'N/A'}}</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-if="activeViewName === 'htda'">
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark>=3">
                <div slot="header" class="tit">
                  <span>合同信息</span>
                </div>
                <div class="text" v-loading="contractLoading">
                  <div class="l">
                    <span style="float: left" class="label">签订日期:</span>
                    <span>{{contract.time}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订地点:</span>
                    <span>{{contract.address}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订人员:</span>
                    <span>{{contract.username}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">客户全称:</span>
                    <span>{{contract.all_name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">展厅负责:</span>
                    <span>{{contract.group_name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">签订合同:</span>
                    <span>{{ contract.contarct_name }}（{{contract.contarct_code}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">代理品牌:</span>
                    <span><el-tag v-for="b in contract.brandList" v-if="b.is_select==1" size="mini" :disable-transitions="true" style="margin-right: 10px" effect="plain">{{b.brand_name}}</el-tag></span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">合同备注:</span>
                    <span>{{contract.remark!==null&&contract.remark!==undefined&&contract.remark!==''?contract.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">合同原件:</span>
                    <el-image v-for="iurl in contractImg"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="contractImg">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" class="base-info" v-if="clientDetail.mark===9" style="margin-top: 20px">
                <div slot="header" class="tit">
                  <span>样品预存款确认单</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">申请人员:</span>
                    <span>{{clientDetail.payinfo.username}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">申请时间:</span>
                    <span>{{clientDetail.payinfo.time}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">招商总监:</span>
                    <span>{{clientDetail.payinfo.dirname}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核时间:</span>
                    <span>{{clientDetail.payinfo.dirtime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核人员:</span>
                    <span>{{clientDetail.payinfo.auditname}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">审核时间:</span>
                    <span>{{clientDetail.payinfo.audittime}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">店面形式:</span>
                    <span>{{clientDetail.payinfo.shopform===0?'商场内店':clientDetail.payinfo.shopform===1?'店中店':clientDetail.payinfo.shopform===2?'沿街店':'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">总面积:</span>
                    <span>{{clientDetail.payinfo.totalarea}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">品牌占用面积:</span>
                    <span>{{clientDetail.payinfo.area}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">门店地址:</span>
                    <span>{{clientDetail.province}}{{clientDetail.city}}{{clientDetail.county}}{{clientDetail.payinfo.address}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款账户:</span>
                    <span>{{clientDetail.payinfo.accountname}}（{{clientDetail.payinfo.accountcard}}）</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款日期:</span>
                    <span>{{clientDetail.payinfo.receipttime}}</span>
                  </div>
                  <div class="l">
                    <span class="label">打款金额:</span>
                    <span>{{clientDetail.payinfo.money}}元</span>
                    <span class="label" style="margin-left: 20px">样品预存款:</span>
                    <span>{{ clientDetail.payinfo.join}}元</span>
                    <span class="label" style="margin-left: 20px">加盟费:</span>
                    <span>{{ clientDetail.payinfo.insure}}元</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款卡号:</span>
                    <span>{{ clientDetail.payinfo.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款备注:</span>
                    <span>{{clientDetail.payinfo.remark!==null&&clientDetail.payinfo.remark!==undefined&&clientDetail.payinfo.remark!==''?clientDetail.payinfo.remark:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">打款凭证:</span>
                    <el-image v-for="iurl in clientDetail.payinfo.payImgs"
                              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px;border: 1px dashed #f5f7fa;"
                              :src="iurl"
                              :preview-src-list="clientDetail.payinfo.payImgs">
                    </el-image>
                  </div>
                </div>
              </el-card>
              <el-card shadow="never" style="margin-top: 20px" class="base-info" v-if="(clientDetail.jmjtk!==null&&clientDetail.mark===9)||clientDetail.mark===7">
                <div slot="header" class="tit">
                  <span>样品预存款退款</span>
                </div>
                <div class="text">
                  <div class="l">
                    <span style="float: left" class="label">收款人:</span>
                    <span>{{clientDetail.jmjtk.name}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">开户行:</span>
                    <span>{{clientDetail.jmjtk.bank}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款金额:</span>
                    <span>{{clientDetail.jmjtk.money}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">收款卡号:</span>
                    <span>{{clientDetail.jmjtk.card}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款原因:</span>
                    <span>{{clientDetail.jmjtk.refundrson!==null&&clientDetail.jmjtk.refundrson!==undefined&&clientDetail.jmjtk.refundrson!==''?clientDetail.jmjtk.refundrson:'N/A'}}</span>
                  </div>
                  <div class="l">
                    <span style="float: left" class="label">退款备注:</span>
                    <span>{{clientDetail.jmjtk.remark!==null&&clientDetail.jmjtk.remark!==undefined&&clientDetail.jmjtk.remark!==''?clientDetail.jmjtk.remark:'N/A'}}</span>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-if="activeViewName === 'dlxx'">
              <el-row :gutter="12">
                <el-col :span="8" v-for="item in clientDetail.brandinfo">
                  <el-card shadow="hover" class="brand-info">
                    <div class="main-info">
                      <el-image
                        style="width: 100%; height: 60px"
                        :src="item.brandlogo"
                        fit="contain"></el-image>
                    </div>
                    <div class="more-info">
                      <div class="info-row">
                        <span class="title">{{item.brandname}}</span>
                      </div>
                      <div class="info-row info-content">
                        <p><span>区域经理：</span>{{item.areaname!==null&&item.areaname!==undefined&&item.areaname!==''?item.areaname:'未分配'}}</p>
                        <p><span>销售客服：</span>{{item.servicename!==null&&item.servicename!==undefined&&item.servicename!==''?item.servicename:'未分配'}}</p>
                        <p><span>报价专员：</span>{{item.offername!==null&&item.offername!==undefined&&item.offername!==''?item.offername:'未分配'}}</p>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div v-if="activeViewName === 'jdxq'" class="project-info" v-loading="overviewLoading">
              <el-alert
                v-if="clientDetail.project===null||clientDetail.project===undefined||clientDetail.project===NaN"
                title="此经销商建店事项还未立项"
                type="warning"
                :closable="false"
                show-icon>
              </el-alert>
              <el-row v-if="clientDetail.project!==null&&clientDetail.project!==undefined&&clientDetail.project!==NaN">
                <el-col :span="14">
                  <div class="overview-box">
                    <div :class="overviewChange===0?'overview-item active':'overview-item'" @click="setOverviewChange(0)">
                      <span>总数</span>
                      <div class="num">{{overviewNum.zs}}</div>
                      <el-progress :percentage="100" color="#3DA8F5" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===1?'overview-item active':'overview-item'" @click="setOverviewChange(1)">
                      <span>已完成</span>
                      <div class="num">{{overviewNum.ywc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.ywc/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===2?'overview-item active':'overview-item'" @click="setOverviewChange(2)">
                      <span>未完成</span>
                      <div class="num">{{overviewNum.wwc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.wwc/overviewNum.zs*100:0" color="#FF8479" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===3?'overview-item active':'overview-item'" @click="setOverviewChange(3)">
                      <span>已逾期</span>
                      <div class="num">{{overviewNum.yyq}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.yyq/overviewNum.zs*100:0" color="#FF9F00" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===4?'overview-item active':'overview-item'" @click="setOverviewChange(4)">
                      <span>待认领</span>
                      <div class="num">{{overviewNum.drl}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.drl/overviewNum.zs*100:0" color="#A1A4D9" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===5?'overview-item active':'overview-item'" @click="setOverviewChange(5)">
                      <span>时间待定</span>
                      <div class="num">{{overviewNum.sjdd}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.sjdd/overviewNum.zs*100:0" color="#9ED979" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===6?'overview-item active':'overview-item'" @click="setOverviewChange(6)">
                      <span>今日到期</span>
                      <div class="num">{{overviewNum.jrdq}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.jrdq/overviewNum.zs*100:0" color="#FFC774" :show-text="false"></el-progress>
                    </div>
                    <div :class="overviewChange===7?'overview-item active':'overview-item'" @click="setOverviewChange(7)">
                      <span>逾期完成</span>
                      <div class="num">{{overviewNum.yqwc}}</div>
                      <el-progress :percentage="overviewNum.zs>0?overviewNum.yqwc/overviewNum.zs*100:0" color="#FF8478" :show-text="false"></el-progress>
                    </div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="info-box">
                    <el-progress type="circle" class="percent" :width="70" :percentage="projectPercent"></el-progress>
                    <div class="name"><el-button @click="goProjectDetail" type="text" icon="el-icon-document" size="mini" style="font-size: 16px;padding: 0">{{clientDetail.project.name}}</el-button></div>
                    <div class="time">{{clientDetail.project.username}}于 {{dateToWz(clientDetail.project.time)}} 创建</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-document"></i><span>项目说明</span></div>
                    <div class="txt">{{clientDetail.project.explain!==null&&clientDetail.project.explain!==''&&clientDetail.project.explain!==undefined?clientDetail.project.explain:'未填写'}}</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-date"></i><span>项目周期</span></div>
                    <div class="txt">{{dateToWz(clientDetail.project.startdate)}} - {{dateToWz(clientDetail.project.enddate)}}</div>
                  </div>
                  <div class="info">
                    <div class="tit"><i class="el-icon-finished"></i><span>项目状态</span></div>
                    <div class="txt">
                      <el-tag v-if="clientDetail.project.mark===0" type="danger" :disable-transitions="true" size="mini">未开始</el-tag>
                      <el-tag v-if="clientDetail.project.mark===1" type="success" :disable-transitions="true" size="mini">进行中</el-tag>
                      <el-tag v-if="clientDetail.project.mark===2" type="warning" :disable-transitions="true" size="mini">已暂停</el-tag>
                      <el-tag v-if="clientDetail.project.mark===3" :disable-transitions="true" size="mini">已完成</el-tag>
                      <el-tag v-if="clientDetail.project.mark===4" type="info" :disable-transitions="true" size="mini">已取消</el-tag>
                    </div>
                  </div>
                </el-col>
                <el-col :span="24" style="padding-top: 20px">
                  <el-table
                    :data="overviewData"
                    border
                    style="width: 100%">
                    <el-table-column
                      type="index"
                      align="center"
                      width="50">
                    </el-table-column>
                    <el-table-column
                      label="计划周期"
                      width="220">
                      <template slot-scope="scope">
                        <span v-if="scope.row.startdate!==null&&scope.row.startdate!==undefined&&scope.row.startdate!==''&&scope.row.enddate!==null&&scope.row.enddate!==undefined&&scope.row.enddate!==''">{{dateToWz(scope.row.startdate)}}-{{dateToWz(scope.row.enddate)}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="taskname"
                      label="事项"
                      width="140">
                    </el-table-column>
                    <el-table-column
                      prop="username"
                      label="执行人"
                      width="80">
                    </el-table-column>
                    <el-table-column
                      label="当前阶段"
                      width="120">
                      <template slot-scope="scope">
                        <span>{{scope.row.stagename}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="当前进度"
                      width="100">
                      <template slot-scope="scope">
                        {{scope.row.psid===0?100:scope.row.percent}}%
                      </template>
                    </el-table-column>
                    <!--                    <el-table-column-->
                    <!--                      label="优先级"-->
                    <!--                      width="120">-->
                    <!--                      <template slot-scope="scope">-->
                    <!--                        <el-tag :type="scope.row.priority===1?'':scope.row.priority===2?'warning':scope.row.priority===3?'danger':'info'" size="small" effect="plain">{{scope.row.priority===1?'普通':scope.row.priority===2?'紧急':scope.row.priority===3?'非常紧急':'较低'}}</el-tag>-->
                    <!--                      </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column
                      prop="stagename"
                      label="实际工期"
                      min-width="220">
                      <template slot-scope="scope">
                        <span v-if="scope.row.startdateReal!==null&&scope.row.startdateReal!==undefined&&scope.row.startdateReal!==''&&scope.row.enddateReal!==null&&scope.row.enddateReal!==undefined&&scope.row.enddateReal!==''">{{dateToWz(scope.row.startdateReal)}}-{{dateToWz(scope.row.enddateReal)}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dynamicVisible"
      title="最新动态"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <ul class="follow-list-ul"
        :key="dynamicKey"
        v-infinite-scroll="getDynamicList"
        :infinite-scroll-disabled="dynamicDisabled">
        <li v-for="d in dynamiclst" class="follow-item">
          <div class="user-info">
            <el-avatar class="photo" shape="square" :size="40" :src="d.photo" @click.native="viewUserInfo(d.userid)"></el-avatar>
            <div class="name" @click="viewUserInfo(d.userid)">{{d.name}}<el-tag size="mini" :type="d.way==='客户录入'?'':d.way==='回归公海'?'danger':'warning'">{{d.way}}</el-tag></div>
            <div class="time">{{d.time}}</div>
          </div>
          <div class="follow-content" v-if="d.content!==null&&d.content!==undefined&&d.content!==''">
            {{d.content}}
          </div>
          <div class="follow-imgs" v-if="d.imgurls.length>0">
            <el-image
              v-for="img in d.imgurls"
              fit="cover"
              class="follow-img"
              :src="img"
              :preview-src-list="d.imgurls"
            />
          </div>
          <div class="client-info" @click="openClientDetails(d.cid)">
            <i class="el-icon-s-custom"></i> {{d.clientname}}<el-divider direction="vertical"></el-divider>{{d.markstr}}
          </div>
        </li>
      </ul>
      <p v-if="dynamicAllLoading" style="text-align: center"><i class="el-icon-loading"></i></p>
      <p v-if="dynamicNoMore" style="text-align: center;font-size: 12px;color: #9aaabf">没有更多了</p>
    </el-dialog>
    <el-dialog
      :visible.sync="userVisible"
      title="人员详情"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div class="view-box" v-loading="userLoading">
        <el-row>
          <el-col :span="8">
            <el-card class="base-info" shadow="never">
              <div slot="header" class="tit">
                <span>人员信息</span>
                <el-dropdown split-button size="small" class="zs-user-info-dropdown">
                  <el-switch
                    v-model="userInfo.mark"
                    :active-value="1"
                    :inactive-value="4"
                    :width="30"
                    @change="changeUserMark"
                    active-text="正常"
                    inactive-text="离职">
                  </el-switch>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="clientTransfer"><i class="el-icon-sort"></i> 客户转移</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="user-info">
                <el-avatar class="photo" shape="square" :size="50" :src="userInfo.photo"></el-avatar>
                <div class="name">{{userInfo.name}}
                  <svg-icon icon-class="client_man" class="client-sex" v-if="userInfo.sex === '男'"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="userInfo.sex === '女'" />
                </div>
                <div class="dept">{{userInfo.dept}}</div>
              </div>
              <div class="count-box">
                <div class="count-item">
                  <div class="num">{{userInfo.addcount}}</div>
                  <div class="txt">新增客户</div>
                </div>
                <div class="count-item">
                  <div class="num">{{userInfo.intentcount}}</div>
                  <div class="txt">意向客户</div>
                </div>
                <div class="count-item">
                  <div class="num">{{userInfo.signcount}}</div>
                  <div class="txt">签约客户</div>
                </div>
              </div>
              <div class="text">
                <div class="l">
                  <span style="float: left" class="label">意向转化率:</span>
                  <el-progress :percentage="userInfo.intentrate"></el-progress>
                </div>
                <div class="l">
                  <span style="float: left" class="label">签约转化率:</span>
                  <el-progress :percentage="userInfo.signrate"></el-progress>
                </div>
                <div class="l">
                  <span style="float: left" class="label">成交转化率:</span>
                  <el-progress :percentage="userInfo.makerate"></el-progress>
                </div>
                <div class="l">
                  <span style="float: left" class="label">数字名片:</span>
                  <span v-if="userInfo.iscard===0" style="color: #F56C6C">未设置</span>
                </div>
                <div v-if="userInfo.iscard===1" style="text-align: center"><el-image :src="smallProgramCode!==null&&smallProgramCode!==undefined&&smallProgramCode!==''?smallProgramCode:qcode_loading" style="height: 150px;width: 150px"></el-image></div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="16" style="padding-left: 20px">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="所有客户" name="first"></el-tab-pane>
              <el-tab-pane label="新增客户" name="second"></el-tab-pane>
              <el-tab-pane label="意向客户" name="fourth"></el-tab-pane>
              <el-tab-pane label="已签客户" name="third"></el-tab-pane>
            </el-tabs>
            <div v-loading="loading">
              <div style="width: 100%;text-align: center;padding: 50px 0;" v-if="!loading&&total<=0">
                <i class="el-icon-document-copy" style="font-size: 5rem;color:rgb(203, 226, 252);"></i>
                <p style="color: #909399">暂无客户数据</p>
              </div>
              <div class="client-list" v-if="total>0">
                <div class="client-item" v-for="c in tableData" @click="openClientDetails(c.cid)">
                  <div class="name">
                    <span>{{c.name}}</span>
                    <svg-icon icon-class="client_man" class="client-sex" v-if="c.sex === 1"/>
                    <svg-icon icon-class="client_women" class="client-sex" v-if="c.sex === 0" />
                  </div>
                  <div class="info-box">
                    <div class="label"><i class="el-icon-medal"></i> 等级</div>
                    <div class="txt" style="padding-top: 8px"><el-rate v-model="c.level" disabled-void-color="#ffffff" disabled></el-rate></div>
                  </div>
                  <div class="info-box">
                    <div class="label"><i class="el-icon-mobile-phone"></i> 电话</div>
                    <div class="txt">{{c.tel}}</div>
                  </div>
                  <div class="info-box">
                    <div class="label"><i class="el-icon-map-location"></i> 地区</div>
                    <div class="txt">{{c.province}} {{c.city}} {{c.county}}</div>
                  </div>
                  <div class="info-box">
                    <div class="label"><i class="el-icon-document"></i> 状态</div>
                    <div class="txt">
                      <el-tag type="danger" :disable-transitions="true" size="mini" v-if="c.is_recycle==1 && c.mark<3">即将回收</el-tag>
                      <el-tag type="warning" :disable-transitions="true" size="mini" v-if="c.is_recycle!=1 && c.mark<3 && c.groupid!=4">待跟进</el-tag>
                      <el-tag type="success" :disable-transitions="true" size="mini" v-if="c.is_recycle!=1 && c.mark<3 && c.groupid==4">已转意向</el-tag>
                      <el-tag size="mini" :disable-transitions="true" v-if="c.mark===3&&c.paymark===9" class="tcf-tag-8">待打款</el-tag>
                      <el-tag size="mini" :disable-transitions="true" v-if="c.mark===3&&c.paymark===0" class="tcf-tag-4">收款审核中</el-tag>
                      <el-tag size="mini" :disable-transitions="true" v-if="c.mark===3&&c.paymark===2" type="danger">收款审核拒绝</el-tag>
                      <el-tag size="mini" :disable-transitions="true" v-if="c.mark===9">已完成</el-tag>
                    </div>
                  </div>
                  <div class="info-box">
                    <div class="label"><i class="el-icon-timer"></i> 跟进</div>
                    <div class="txt" :style="c.is_recycle==1&&c.mark<3?'color:#F56C6C':''">{{c.followtime}}</div>
                  </div>
                </div>
              </div>
              <el-pagination
                v-if="total>0"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      title="客户转移"
      :visible.sync="tranDialog"
      width="40%"
      :destroy-on-close="true"
      :append-to-body="true"
      :lock-scroll="true">
      <el-form size="small" ref="tranForm" :model="tranForm" label-width="80px" :rules="tranRules">
        <el-alert
          title="只能将正在跟进中的客户进行转移"
          style="margin-bottom: 20px"
          type="warning"
          show-icon
          :closable="false">
        </el-alert>
        <el-form-item label="转移给" prop="userid">
          <el-select v-model="tranForm.userid" filterable placeholder="请选择">
            <el-option
              v-for="u in teamlst"
              v-if="userInfo.userid!==u.userid"
              :label="u.name"
              :value="u.userid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="tranLoading" type="primary" @click="submitTranEdit">立即转移</el-button>
          <el-button @click="tranDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="mreditTitle"
      :visible.sync="mreditDialog"
      width="40%"
      :destroy-on-close="true"
      :append-to-body="true"
      :lock-scroll="true">
      <el-form size="small" ref="eForm" :model="eForm" :rules="eRules" label-width="90px" >
        <el-form-item label="城市" prop="city">
          <el-cascader
            style="width:100%"
            v-model="eForm.city"
            :options="cityoptions"
            placeholder="请选择调研城市"
            filterable></el-cascader>
        </el-form-item>
        <el-form-item label="调研时间" prop="time">
          <el-date-picker
            v-model="eForm.time"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="市场情况分析" prop="market">
          <el-input type="textarea" v-model="eForm.market" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="入住品牌情况" prop="brand">
          <el-input type="textarea" v-model="eForm.brand" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="eForm.remark" maxlength="400"  show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="招商经理建议" prop="mansug">
          <el-input type="textarea" v-model="eForm.mansug" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="招商总监建议" prop="dirsug">
          <el-input type="textarea" v-model="eForm.dirsug" maxlength="400" show-word-limit :rows="4" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="mreditLoading" @click="submitEdit" type="primary" >立即提交</el-button>
          <el-button @click="mreditDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="detailTitle"
      :visible.sync="detailVisible"
      width="40%"
      top="10vh"
      :lock-scroll="true"
      :append-to-body="true">
      <div v-loading="detailLoading">
        <div style="margin-bottom: 5px">调研人：{{detail.name}}</div>
        <div style="margin-bottom: 5px">调研城市：{{detail.province}} - {{detail.city}}</div>
        <div style="margin-bottom: 5px">调研时间：{{detail.startdate}} - {{detail.enddate}}</div>
        <div style="margin-top: 20px;margin-bottom: 10px">市场情况分析</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.market}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">入住品牌情况</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.brand}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">备注</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.remark}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">招商经理建议</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.mansug}}</div>
        </el-card>
        <div style="margin-top: 20px;margin-bottom: 10px">招商总监建议</div>
        <el-card class="box-card" shadow="never">
          <div>{{detail.dirsug}}</div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import conversion_rates from '@/assets/conversion_rates.png'
import * as echarts from 'echarts'
import {
  getTodayMerchantsData,
  getMerchantsDataBriefing,
  getMerchantsClientList,
  forwardClient,
  getClientDetail,
  getClentFollowList,
  getSignedContract,
  getMerchantsClientDataAnalysis,
  getMerchantsClientSourceAnalysis,
  getMerchantsDynamicList,
  getMerchantsTeamList,
  getMerchantsTeamDetail,
  getClientList,
  editMerchantsTeamUserMark,
  editMerchantsTeamClientTran,
  getProjectTaskListByPid,
  selectMarketResearchList,
  editMarketResearch, delMarketResearch, selectOneByIdMarketResearch
} from '@/api/work'
import { formatMoney } from '@/utils/index'
import { formatDate } from '@/api/pub'
import elichain_photo from '@/assets/elichain_photo.jpg'
import qcode_loading from '@/assets/qcode_loading.jpg'
import { getSmallProgramCode } from '@/api/zsxcx'
import { getCity } from '@/utils/city'

export default {
  name: 'zsszkb',
  data() {
    return {
      formatMoney: formatMoney,
      elichain_photo: elichain_photo,
      conversion_rates: conversion_rates,
      todayData: {
        add: 0,
        inten: 0,
        signup: 0,
        payback: 0
      },
      sjjbtime: [],
      dataBriefingLoading: false,
      dataBriefing: {
        add: 0,
        changeintent: 0,
        changesign: 0,
        inten: 0,
        signup: 0,
        payback: 0,
        paybackmoney: 0,
        intentrates: 0,
        signrates: 0,
        makerates: 0
      },
      clientlistType: 0,
      clientVisible: false,
      clientLoading: false,
      clientData: [],
      clientCurrentPage: 1,
      clientTotal: 0,
      clientPageSize: 10,
      clientTableKey: '',
      khsjfxtime: [],
      khlytime: [],
      qsType: 0, // 0客户趋势    1客户对比
      qsDateType: 1, // 1按日   0按月
      khsjfxKey: '',
      khsjfxFormat: 'yyyy年MM月dd日',
      khsjfxValueFormat: 'yyyy-MM-dd',
      khsjfxType: 'daterange',
      dbType: 0, // 0新增客户   1意向客户   2签约客户
      dataAnalysisLoading: false,
      sourceAnalysisLoading: false,
      dynamicLoading: false,
      newdynamiclst: [],
      viewVisible: false,
      viewLoading: false,
      clientDetail: {
        areadealerlst: [],
        project: {}
      },
      areaKey: '',
      forwardKey: '',
      detailKey: '',
      activeViewName: 'gjjl',
      followLoading: false,
      followList: [],
      contractLoading: false,
      contract: {},
      contractImg: [],
      dynamicVisible: false,
      dynamicpage: 1,
      dynamicAllLoading: false,
      dynamiclst: [],
      dynamicTotal: 0,
      dynamicKey: '',
      teamloading: false,
      teamlst: [],
      smallProgramCode: '',
      qcode_loading: qcode_loading,
      userVisible: false,
      userLoading: false,
      userInfo: {},
      activeName: 'first',
      groupid: 1,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      loading: false,
      search: '',
      tranDialog: false,
      tranForm: {
        userid: null
      },
      tranRules: {
        userid: [{ required: true, message: '请选择转移人员', trigger: 'change' }]
      },
      tranLoading: false,
      overviewLoading: false,
      overviewBaseData: [],
      overviewData: [],
      projectPercent: 0,
      overviewNum: {
        zs: 0,
        ywc: 0,
        wwc: 0,
        yyq: 0,
        drl: 0,
        sjdd: 0,
        jrdq: 0,
        yqwc: 0
      },
      overviewChange: 0,
      marketResearchData: [],
      mrloading: false,
      mrtotal: 0,
      mrcurrentPage: 1,
      mrpageSize: 20,
      eForm: {
        mrid: 0,
        userid: null,
        city: [],
        time: [],
        market: '',
        brand: '',
        remark: '',
        mansug: '',
        dirsug: ''
      },
      mreditDialog: false,
      mreditLoading: false,
      mreditTitle: '',
      eRules: {
        city: [{ type: 'array', required: true, message: '请选择城市', trigger: 'blur' }],
        time: [{ required: true, message: '请选择时间', trigger: 'change' }]
      },
      cityoptions: [],
      detailVisible: false,
      detailLoading: false,
      detailTitle: '',
      detail: {
        mrid: null,
        userid: null,
        province: '',
        city: '',
        startdate: '',
        enddate: '',
        market: '',
        brand: '',
        remark: '',
        mansug: '',
        dirsug: '',
        name: ''
      },
      yxjpayImgs: []
    }
  },
  computed: {
    user: getUser,
    dynamicNoMore() {
      return this.dynamicTotal < 10
    },
    dynamicDisabled() {
      return this.dynamicAllLoading || this.dynamicNoMore
    }
  },
  created() {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    this.sjjbtime.push(year + '-' + (month > 9 ? month : '0' + month) + '-01')
    this.sjjbtime.push(year + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day))
    this.khlytime = this.sjjbtime
    this.khsjfxtime = this.sjjbtime
    this.getTodayData()
    this.getDataBriefing()
    this.getNewDynamicList()
    this.getTeamList()
    let _cityoptions = getCity()
    for (let a of _cityoptions) {
      for (let b of a.children) {
        b.children = null
      }
    }
    this.cityoptions = _cityoptions
    this.selectMarketResearchList()
  },
  mounted() {
    this.getQsData()
    this.getClientSource()
  },
  methods: {
    openDetails(row) {
      this.detailVisible = true
      this.detailLoading = true
      selectOneByIdMarketResearch({ userid: this.user.dUserid, mrid: row.mrid }).then(response => {
        this.detail = response.data
        this.detailTitle = response.data.province + '-' + response.data.city + ' 调研详情'
        this.detailLoading = false
      }).catch(() => {
        this.detailLoading = false
      })
    },
    delRow(row) {
      this.$confirm('您确定要删除此调研吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        const data = {
          mrid: row.mrid,
          userid: this.user.dUserid
        }
        delMarketResearch(data).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.selectMarketResearchList()
        })
      }).catch(() => {})
    },
    submitEdit() {
      this.$refs['eForm'].validate((valid) => {
        if (valid) {
          this.$confirm('您确定要提交此调研吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (!this.mreditloading) {
              this.mreditloading = true
              const data = {
                mrid: this.eForm.mrid,
                userid: this.eForm.userid,
                groupid: this.user.dGroupid,
                province: this.eForm.city[0],
                city: this.eForm.city[1],
                startdate: this.eForm.time[0],
                enddate: this.eForm.time[1],
                market: this.eForm.market,
                brand: this.eForm.brand,
                remark: this.eForm.remark,
                mansug: this.eForm.mansug,
                dirsug: this.eForm.dirsug
              }
              editMarketResearch(data).then(response => {
                this.$message({
                  type: 'success',
                  message: response.msg
                })
                this.mreditloading = false
                this.mreditDialog = false
                this.selectMarketResearchList()
              })
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    editRow(row) {
      if (row !== null) {
        this.mreditTitle = '编辑调研'
        this.eForm = {
          mrid: row.mrid,
          userid: row.userid,
          city: [row.province, row.city],
          time: [row.startdate, row.enddate],
          market: row.market,
          brand: row.brand,
          remark: row.remark,
          mansug: row.mansug,
          dirsug: row.dirsug
        }
      } else {
        this.mreditTitle = '添加调研'
        this.eForm = {
          mrid: 0,
          userid: this.user.dUserid,
          city: [],
          time: [],
          market: '',
          brand: '',
          remark: '',
          mansug: '',
          dirsug: ''
        }
      }
      this.mreditDialog = true
    },
    selectMarketResearchList() {
      this.mrloading = true
      const data = {
        userid: 0,
        page: this.mrcurrentPage,
        limit: this.mrpageSize,
        groupid: this.user.dGroupid
      }
      selectMarketResearchList(data).then(response => {
        this.mrloading = false
        this.marketResearchData = response.data
        this.mrtotal = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    mrhandleSizeChange(val) {
      this.mrpageSize = val
      this.selectMarketResearchList()
    },
    mrhandleCurrentChange(val) {
      this.mrcurrentPage = val
      this.selectMarketResearchList()
    },
    goProjectDetail() {
      this.viewVisible = false
      this.$router.push({ path: '/work/project_detail/' + this.clientDetail.project.pid })
    },
    dateToWz(d) {
      if (d !== null && d !== undefined) {
        if (d.length > 10) {
          d = d.substring(0, 10)
        }
        const darr = d.split('-')
        return darr[0] + '年' + darr[1] + '月' + darr[2] + '日'
      } else {
        return ''
      }
    },
    setOverviewChange(n) {
      this.overviewChange = n
      this.filterOverviewData()
    },
    filterOverviewData() {
      let _overviewData = []
      const newDate = new Date()
      const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
      for (const t of this.overviewBaseData) {
        if (this.overviewChange === 0) {
          _overviewData.push(t)
        } else if (this.overviewChange === 1) {
          if (t.psid === 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 2) {
          if (t.psid !== 0) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 3) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        } else if (this.overviewChange === 4) {
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 5) {
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _overviewData.push(t)
          }
        } else if (this.overviewChange === 6) {
          if (t.psid !== 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _overviewData.push(t)
              }
            }
          }
        } else if (this.overviewChange === 7) {
          if (t.psid === 0) {
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _overviewData.push(t)
                }
              }
            }
          }
        }
      }
      this.overviewData = _overviewData
    },
    getProjectTask() {
      this.overviewLoading = true
      getProjectTaskListByPid({ pid: this.clientDetail.project.pid }).then(response => {
        this.overviewBaseData = response.data
        let _ywc = 0, _wwc = 0, _yyq = 0, _drl = 0, _sjdd = 0, _jrdq = 0, _yqwc = 0
        const newDate = new Date()
        const today = `${newDate.getFullYear()}-${newDate.getMonth() < 9 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1}-${newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()}`
        let unp = 0.0
        let _projectPercent = 0.0
        if (response.data.length > 0) {
          unp = 100 / response.data.length
        }
        for (const t of response.data) {
          if (t.psid === 0) {
            _projectPercent = _projectPercent + unp
            _ywc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '' && t.enddateReal !== undefined && t.enddateReal !== null && t.enddateReal !== '') {
              if (t.enddate !== today) {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(t.enddateReal)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yqwc++
                }
              }
            }
          } else {
            if (t.percent > 0) {
              _projectPercent = _projectPercent + (t.percent / 100 * unp)
            }
            _wwc++
            if (t.enddate !== null && t.enddate !== undefined && t.enddate !== '') {
              if (t.enddate === today) {
                _jrdq++
              } else {
                const oDate1 = new Date(t.enddate)
                const oDate2 = new Date(today)
                if (oDate1.getTime() < oDate2.getTime()) {
                  _yyq++
                }
              }
            }
          }
          if (t.userid === 0 || t.userid === null || t.userid === undefined) {
            _drl++
          }
          if (t.enddate === null || t.enddate === undefined || t.enddate === '') {
            _sjdd++
          }
        }
        this.projectPercent = Math.floor(_projectPercent)
        this.overviewNum = {
          zs: response.data.length,
          ywc: _ywc,
          wwc: _wwc,
          yyq: _yyq,
          drl: _drl,
          sjdd: _sjdd,
          jrdq: _jrdq,
          yqwc: _yqwc
        }
        this.filterOverviewData()
        this.overviewLoading = false
      })
    },
    submitTranEdit() {
      this.$refs['tranForm'].validate((valid) => {
        if (valid) {
          if (!this.tranLoading) {
            this.tranLoading = true
            const data = {
              olduserid: this.userInfo.userid,
              userid: this.tranForm.userid,
              operid: this.user.dUserid
            }
            editMerchantsTeamClientTran(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.tranLoading = false
              this.tranDialog = false
              this.viewUserInfo(this.userInfo.userid)
              this.getTeamList()
            }).catch(() => {
              this.tranLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    clientTransfer() {
      this.tranForm = {
        userid: null
      }
      this.tranDialog = true
    },
    changeUserMark(v) {
      editMerchantsTeamUserMark({
        userid: this.userInfo.userid,
        mark: v
      }).then(res => {
        this.getTeamList()
      }).catch(() => {})
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.userInfo.userid,
        groupid: this.groupid,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize
      }
      getClientList(data).then(response => {
        this.loading = false
        let _tableData = response.data
        for (let t of _tableData) {
          t.followtime = formatDate(Date.parse(t.followtime))
        }
        this.tableData = _tableData
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    handleClick(tab, event) {
      let _groupid = 1
      if (tab.index == 1) {
        _groupid = 2
      } else if (tab.index == 2) {
        _groupid = 4
      } else if (tab.index == 3) {
        _groupid = 3
      }
      if (_groupid === this.groupid) {
        return
      }
      this.groupid = _groupid
      this.currentPage = 1
      this.getData()
    },
    viewUserInfo(userid) {
      this.smallProgramCode = ''
      this.groupid = 1
      this.currentPage = 1
      this.pageSize = 10
      this.activeName = 'first'
      this.search = ''
      this.userVisible = true
      this.userLoading = true
      getMerchantsTeamDetail({ userid: userid }).then(res => {
        this.userInfo = res.data
        if (res.data.iscard === 1) {
          this.getSmallProgramCode(userid)
        }
        this.userLoading = false
        this.getData()
      }).catch(() => {
        this.userLoading = false
      })
    },
    getSmallProgramCode(userid) {
      this.smallProgramCode = ''
      const data = {
        scene: 'staffid=' + userid,
        page: 'pages/businesscard/businesscard'
      }
      getSmallProgramCode(data).then(response => {
        this.smallProgramCode = response.msg
      })
    },
    getTeamList() {
      this.teamloading = true
      getMerchantsTeamList({ groupid: this.user.dGroupid }).then(res => {
        this.teamlst = res.data
        this.teamloading = false
      }).catch(() => {
        this.teamloading = false
      })
    },
    viewDynamic() {
      this.dynamicpage = 1
      this.dynamiclst = []
      this.dynamicTotal = 10
      this.dynamicKey = new Date().getTime()
      this.dynamicVisible = true
    },
    getDynamicList() {
      this.dynamicAllLoading = true
      getMerchantsDynamicList({
        groupid: this.user.dGroupid,
        page: this.dynamicpage,
        limit: 10
      }).then(res => {
        this.dynamicpage = this.dynamicpage + 1
        let _dynamiclst = this.dynamiclst
        for (let d of res.data) {
          d.time = formatDate(Date.parse(d.time))
          _dynamiclst.push(d)
        }
        this.dynamiclst = _dynamiclst
        this.dynamicTotal = res.data.length
        this.dynamicAllLoading = false
      }).catch(() => {
        this.dynamicAllLoading = false
      })
    },
    getNewDynamicList() {
      this.dynamicLoading = true
      getMerchantsDynamicList({
        groupid: this.user.dGroupid,
        page: 1,
        limit: 9
      }).then(res => {
        let _newdynamiclst = res.data
        for (let d of _newdynamiclst) {
          d.time = formatDate(Date.parse(d.time))
        }
        this.newdynamiclst = _newdynamiclst
        this.dynamicLoading = false
      }).catch(() => {
        this.dynamicLoading = false
      })
    },
    openClientDetails(cid) {
      this.areaKey = new Date().getTime()
      this.forwardKey = this.areaKey + 1
      this.detailKey = this.areaKey + 2
      this.followList = []
      this.activeViewName = 'gjjl'
      this.viewVisible = true
      this.viewLoading = true
      const data = {
        userid: this.user.dUserid,
        clientid: cid,
        groupid: this.user.dGroupid
      }
      getClientDetail(data).then(response => {
        this.clientDetail = response.data
        this.clientDetail.createtime = formatDate(Date.parse(this.clientDetail.createtime))
        if (this.clientDetail.mark === 9) {
          let _payImgs = []
          for (let img of this.clientDetail.payinfo.imglst) {
            _payImgs.push(img.imgurl)
          }
          this.clientDetail.payinfo.payImgs = _payImgs
        }
        this.viewLoading = false
        this.getFollowList()
        if (this.clientDetail.mark >= 3) {
          this.getContractDetail()
        }
        let _clientInmon = this.clientDetail.clientInmon
        if (_clientInmon !== null && _clientInmon !== undefined) {
          let _yxjpayImgs = []
          for (let img of _clientInmon.clientInmonImgList) {
            _yxjpayImgs.push(img.imgurl)
          }
          this.yxjpayImgs = _yxjpayImgs
        }
        if (this.clientDetail.mark === 9) {
          if (this.clientDetail.project !== null && this.clientDetail.project !== undefined && this.clientDetail.project !== NaN) {
            this.getProjectTask()
          }
        }
      }).catch(() => {
        this.viewLoading = false
      })
    },
    getContractDetail() {
      this.contract = {}
      this.contractImg = []
      this.contractLoading = true
      getSignedContract({ signid: this.clientDetail.cid }).then(response => {
        this.contract = response.data
        this.contractLoading = false
        let imgs = []
        for (let c of this.contract.imgList) {
          imgs.push(c.img_url)
        }
        this.contractImg = imgs
      }).catch(() => {
        this.contractLoading = false
      })
    },
    getFollowList() {
      this.followLoading = true
      getClentFollowList({ cid: this.clientDetail.cid }).then(response => {
        this.followLoading = false
        let _followList = response.data
        for (let t of _followList) {
          let _imgurlarr = []
          t.time = formatDate(Date.parse(t.time))
          for (const i of t.imglst) {
            _imgurlarr.push(i.imgurl)
          }
          t.imgurlarr = _imgurlarr
        }
        this.followList = _followList
      }).catch(() => {
        this.followLoading = false
      })
    },
    forwardC(u) {
      this.$confirm('确认将客户“' + this.clientDetail.name + '”移交给 ' + u.dName + ' 吗?', '移交客户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        forwardClient({
          cid: this.clientDetail.cid,
          operuserid: this.user.dUserid,
          userid: u.dUserid
        }).then(response => {
          this.$message({
            message: `客户已移交给${u.dName}`,
            type: 'success'
          })
          this.viewVisible = false
          this.openClientDetails(this.clientDetail.cid)
        }).catch(() => {})
      }).catch(() => {})
    },
    viewClientList(n) {
      this.clientlistType = n
      this.clientTableKey = new Date().getTime()
      this.clientVisible = true
      this.clientCurrentPage = 1
      this.clientTotal = 0
      this.clientPageSize = 10
      this.getClientList()
    },
    handleSizeChangeClient(val) {
      this.clientPageSize = val
      this.getClientList()
    },
    handleCurrentChangeClient(val) {
      this.clientCurrentPage = val
      this.getClientList()
    },
    getClientList() {
      this.clientLoading = true
      const data = {
        type: this.clientlistType,
        groupid: this.user.dGroupid,
        starttime: this.sjjbtime[0],
        endtime: this.sjjbtime[1],
        page: this.clientCurrentPage,
        limit: this.clientPageSize
      }
      getMerchantsClientList(data).then(res => {
        this.clientData = res.data
        this.clientTotal = res.total
        this.clientLoading = false
      }).catch(() => {
        this.clientLoading = false
      })
    },
    changeDbType(n) {
      if (this.dbType === n) {
        return false
      }
      this.dbType = n
      this.getQsData()
    },
    changeQsDateType(n) {
      if (this.qsDateType === n) {
        return false
      }
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      if (n === 0) { // 按y月
        this.khsjfxFormat = 'yyyy年MM月'
        this.khsjfxValueFormat = 'yyyy-MM'
        this.khsjfxType = 'monthrange'
        this.khsjfxtime = [year + '-01', year + '-' + (month > 9 ? month : '0' + month)]
      } else { // 按日
        this.khsjfxFormat = 'yyyy年MM月dd日'
        this.khsjfxValueFormat = 'yyyy-MM-dd'
        this.khsjfxType = 'daterange'
        this.khsjfxtime = [year + '-' + (month > 9 ? month : '0' + month) + '-01', year + '-' + (month > 9 ? month : '0' + month) + '-' + (day > 9 ? day : '0' + day)]
      }
      this.qsDateType = n
      this.khsjfxKey = new Date().getTime()
      this.getQsData()
      return true
    },
    changeQs(n) {
      if (this.qsType === n) {
        return
      }
      this.qsType = n
      if (n === 1) {
        if (!this.changeQsDateType(0)) {
          this.getQsData()
        }
      } else {
        if (!this.changeQsDateType(1)) {
          this.getQsData()
        }
      }
    },
    getQsData() {
      let clientKhsjfxChart = echarts.getInstanceByDom(document.getElementById('khsjfxChart'))
      if (clientKhsjfxChart == null) {
        clientKhsjfxChart = echarts.init(document.getElementById('khsjfxChart'))
      }
      clientKhsjfxChart.clear()
      this.dataAnalysisLoading = true
      const data = {
        groupid: this.user.dGroupid,
        starttime: this.khsjfxtime[0],
        endtime: this.khsjfxtime[1],
        type: this.qsType,
        qstype: this.qsType === 0 ? this.qsDateType : this.dbType
      }
      getMerchantsClientDataAnalysis(data).then(res => {
        let option = {}
        if (this.qsType === 0) { // 客户趋势
          option = {
            title: false,
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              orient: 'horizontal', // 'vertical'
              x: 'center', // 'center' | 'left' | {number},
              y: 'bottom', // 'center' | 'bottom' | {number}
              itemGap: 20,
              data: [
                { name: '新增客户', icon: 'circle' },
                { name: '意向客户', icon: 'circle' },
                { name: '签约客户', icon: 'circle' }
              ],
              selected: { '新增客户': true, '意向客户': true, '签约客户': true }
            },
            color: ['#E6A23C', '#67C23A', '#409EFF'],
            toolbox: false,
            grid: {
              left: '20px',
              right: '20px',
              bottom: '40px',
              top: '20px',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                data: res.data.xAxisData
              }
            ],
            yAxis: {
              type: 'value',
              axisLabel: {
                show: true,
                color: '#404852'
              },
              axisLine: {
                lineStyle: {
                  color: '#c5c5c5',
                  width: 1
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed'
                }
              }
            },
            series: [
              {
                name: '新增客户',
                type: 'line',
                smooth: true,
                showSymbol: true,
                data: res.data.addcounts,
                lineStyle: {
                  width: 1
                }
              },
              {
                name: '意向客户',
                type: 'line',
                smooth: true,
                showSymbol: true,
                data: res.data.intentcounts,
                lineStyle: {
                  width: 1
                }
              },
              {
                name: '签约客户',
                type: 'line',
                smooth: true,
                showSymbol: true,
                data: res.data.sgincounts,
                lineStyle: {
                  width: 1
                }
              }
            ]
          }
        } else { // 客户对比
          option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            color: ['#67C23A', '#409EFF'],
            legend: {
              orient: 'horizontal', // 'vertical'
              x: 'center', // 'center' | 'left' | {number},
              y: 'bottom' // 'center' | 'bottom' | {number}
            },
            grid: {
              left: '0',
              right: '0',
              bottom: '40px',
              top: '20px',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: res.data.xAxisData
              }
            ],
            yAxis: [
              {
                type: 'value',
                axisLabel: {
                  show: true,
                  color: '#404852'
                },
                axisLine: {
                  lineStyle: {
                    color: '#c5c5c5',
                    width: 1
                  }
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              }
            ],
            series: [
              {
                name: `对比去年${this.dbType === 1 ? '意向' : this.dbType === 2 ? '签约' : '新增'}客户`,
                type: 'bar',
                emphasis: {
                  focus: 'series'
                },
                label: {
                  show: true,
                  position: 'top'
                },
                data: res.data.oldcounts
              },
              {
                name: `当前月份${this.dbType === 1 ? '意向' : this.dbType === 2 ? '签约' : '新增'}客户`,
                type: 'bar',
                emphasis: {
                  focus: 'series'
                },
                label: {
                  show: true,
                  position: 'top'
                },
                data: res.data.counts
              }
            ]
          }
        }
        clientKhsjfxChart.setOption(option, true)
        this.dataAnalysisLoading = false
      }).catch(() => {
        this.dataAnalysisLoading = false
      })
    },
    getClientSource() {
      let clientSourceChart = echarts.getInstanceByDom(document.getElementById('clientSource'))
      if (clientSourceChart == null) {
        clientSourceChart = echarts.init(document.getElementById('clientSource'))
      }
      clientSourceChart.clear()
      this.sourceAnalysisLoading = true
      getMerchantsClientSourceAnalysis({
        groupid: this.user.dGroupid,
        starttime: this.khlytime[0],
        endtime: this.khlytime[1]
      }).then(res => {
        const datas = [res.data]
        const option = {
          legend: false,
          toolbox: false,
          series: datas.map(function(data, idx) {
            var top = idx * 100
            return {
              type: 'pie',
              top: top + '%',
              height: '100%',
              left: 'center',
              width: '100%',
              radius: [30, 140],
              roseType: 'area',
              itemStyle: {
                borderRadius: 8
              },
              label: {
                alignTo: 'edge',
                formatter: '{name|{b}} {d}%\n{time|{c} 位}',
                minMargin: 5,
                edgeDistance: 0,
                lineHeight: 20,
                fontSize: 13,
                rich: {
                  time: {
                    fontSize: 13,
                    color: '#999'
                  }
                }
              },
              labelLine: {
                length: 15,
                length2: 0,
                maxSurfaceAngle: 80
              },
              labelLayout: function(params) {
                const isLeft = params.labelRect.x < clientSourceChart.getWidth() / 2
                const points = params.labelLinePoints
                // Update the end point.
                points[2][0] = isLeft
                  ? params.labelRect.x
                  : params.labelRect.x + params.labelRect.width
                return {
                  labelLinePoints: points
                }
              },
              data: data
            }
          })
        }
        clientSourceChart.setOption(option, true)
        this.sourceAnalysisLoading = false
      }).catch(() => {
        this.sourceAnalysisLoading = false
      })
    },
    getTodayData() {
      getTodayMerchantsData({ groupid: this.user.dGroupid }).then(res => {
        this.todayData = res.data
      }).catch(() => {})
    },
    getDataBriefing() {
      this.dataBriefingLoading = true
      getMerchantsDataBriefing({ groupid: this.user.dGroupid, starttime: this.sjjbtime[0], endtime: this.sjjbtime[1] }).then(res => {
        this.dataBriefing = res.data
        this.dataBriefingLoading = false
      }).catch(() => {
        this.dataBriefingLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.zsszkb-container{
  .today-box{
    border-radius: 2px;
    -webkit-box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
    box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
    background: #ffffff;
    .today-item{
      .today-data{
        width: 100%;
        position: relative;
        padding: 20px 15px 20px 70px;
        .tit{
          font-size: 12px;
          color: #666;
          margin-bottom: 4px;
        }
        .num{
          font-size: 14px;
          font-weight: 500;
          color: #4a4a4a;
          span{
            margin-left: 10px;
            font-size: 12px;
            font-weight: normal;
          }
        }
        .icon{
          width: 46px;
          height: 46px;
          border-radius: 50%;
          text-align: center;
          line-height: 46px;
          position: absolute;
          top: 18px;
          left: 15px;
          i{
            font-size: 23px;
          }
        }
      }
      &:nth-child(1){
        .today-data{
          .icon{
            background: #fdf6ec;
            i{
              color: #e6a23c;
            }
          }
        }
      }
      &:nth-child(2){
        .today-data{
          .icon{
            background: #f0f9eb;
            i{
              color: #67c23a;
            }
          }
        }
      }
      &:nth-child(3){
        .today-data{
          .icon{
            background: #ecf5ff;
            i{
              color: #409eff;
            }
          }
        }
      }
      &:nth-child(4){
        .today-data{
          .icon{
            background: #fef0f0;
            i{
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
  .state-box{
    width: 100%;
    position: relative;
    .state-list{
      width: 100%;
      position: relative;
      .state-item{
        height: 64px;
        display: block;
        &:first-child{
          background: rgba(64,158,255,.08);
        }
        &:nth-child(2){
          background: rgba(110,179,255,.06);
        }
        &:nth-child(3){
          background: rgba(110,179,255,.04);
        }
        &:before{
          display: table;
          content: " ";
        }
        &:after{
          content: ".";
          display: block;
          height: 0;
          clear: both;
          visibility: hidden;
        }
        .state-class{
          float: left;
          min-width: 100px;
          padding: 15px 0 11px 30px;
          .state-data{
            line-height: 22px;
            white-space: nowrap;
            font-size: 13px;
            color: #4a4a4a;
          }
          .state-title{
            position: relative;
            font-size: 12px;
            color: #666;
            line-height: 16px;
            cursor: pointer;
            i{
              color: #9aaabf;
            }
          }
        }
      }
    }
    .state-pic{
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 320px;
      .pic{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        height: 192px;
        background-size: 100% 100%;
        width: 288px;
        z-index: 2;
      }
      &:after{
        position: absolute;
        top: 0;
        right: 0;
        content: "";
        width: 60%;
        height: 100%;
        background: #fff;
        z-index: 1;
      }
    }
    .growth{
      position: absolute;
      top: 55px;
      right: 57px;
      z-index: 3;
      .growth-title{
        color: #666;
        line-height: 20px;
        font-size: 12px;
        .percentage{
          margin-top: 15px;
          font-size: 13px;
          line-height: 22px;
          color: #353535;
        }
      }

    }
    .fk{
      top: 120px;
      right: 84px;
    }
    .cj{
      top: 82px;
      right: 0;
    }
  }
  .follow-list{
    height: 1148px;
    overflow: hidden;
    position: relative;
    .follow-item{
      width: 100%;
      position: relative;
      margin-bottom: 25px;
      &:last-child{
        margin-bottom: 0;
      }
      .user-info{
        width: 100%;
        position: relative;
        padding-left: 50px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
          cursor: pointer;
        }
        .name{
          font-size: 13px;
          font-weight: 500;
          margin-bottom: 2px;
          cursor: pointer;
          span{
            font-size: 12px;
            margin-left: 10px;
          }
        }
        .time{
          font-size: 12px;
          color:#999;
        }
      }
      .follow-content{
        padding-top: 10px;
        font-size: 13px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }
      .client-info{
        margin-top: 5px;
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        padding: 5px 10px;
        font-size: 12px;
        color: #9aaabf;
        cursor: pointer;
      }
    }
  }
}
.view-box{
  width: 100%;
  position: relative;
  .base-info{
    width: 100%;
    position: relative;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
    .text{
      font-size: 13px;
      .l{
        margin-bottom: 15px;
        .label{
          color: #828792;
          margin-right: 14px;
        }
        .name{
          font-weight: 500;
          font-size: 14px;
        }
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
        &:last-child{
          margin-bottom: 0;
        }
        &:after{
          content: ' ';
          display: table;
          clear: both;
        }
      }
    }
    .user-info{
      width: 100%;
      position: relative;
      padding-left: 60px;
      margin-bottom: 20px;
      .photo{
        position: absolute;
        top: 0;
        left: 0;
      }
      .name{
        font-size: 14px;
        font-weight: 500;
        padding-top: 4px;
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
      }
      .dept{
        padding-top: 6px;
        font-size: 12px;
        color: #999999;
      }
    }
    .count-box{
      width: 100%;
      position: relative;
      margin-bottom: 20px;
      background-color: #f4f4f5;
      border-radius: 4px;
      padding: 10px 0;
      &:after{
        content: ' ';
        display: table;
        clear: both;
      }
      .count-item{
        float: left;
        width: 33.33%;
        text-align: center;
        .num{
          font-size: 15px;
          font-weight: 500;
        }
        .txt{
          font-size: 12px;
          color: #828792;
        }
      }
    }
  }
  .principal{
    width: 100%;
    position: relative;
    margin-top: 20px;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
  }
  .follow-from{
    width: 100%;
    position: relative;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
    border-radius: 4px;
    padding-bottom: 10px;
    .follow-img-box{
      width: 100%;
      position: relative;
      padding: 5px 15px;
    }
    .btn-box{
      border-bottom: 1px solid #EBEEF5;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      padding: 0 15px;
    }
  }
  .follow-list{
    width: 100%;
    position: relative;
    .edit-btn{
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
    }
    .follow-item{
      width: 100%;
      position: relative;
      border: 1px solid #EBEEF5;
      margin-bottom: 20px;
      border-radius: 4px;
      padding: 15px;
      .follow-userinfo{
        width: 100%;
        position: relative;
        padding-left: 60px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
        }
        .name{
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 4px;
          padding-top: 4px;
          span{
            font-size: 12px;
            margin-left: 10px;
          }
        }
        .time{
          font-size: 12px;
          color:#999;
        }
      }
      .follow-content{
        padding-top: 15px;
        font-size: 13px;
      }
      .follow-imgs{
        width: 100%;
        position: relative;
        margin-top: 10px;
        .follow-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
  }
  .brand-info{
    margin:6px 0;
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
  .client-list{
    width: 100%;
    position: relative;
    &:after{
      content: ' ';
      display: table;
      clear: both;
    }
    .client-item{
      width: 247px;
      float: left;
      margin-bottom: 17px;
      margin-right: 17px;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      overflow: hidden;
      color: #303133;
      position: relative;
      cursor: pointer;
      padding: 5px 15px;
      transition: .3s;
      &:hover{
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
      }
      .name{
        padding: 10px 0;
        span{
          font-size: 14px;
          font-weight: 500;
        }
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
        .mark{
          float: right;
          .el-dropdown-link{
            color: #828792;
          }
        }
      }
      .info-box{
        width: 100%;
        position: relative;
        height: 36px;
        line-height: 36px;
        .label{
          width: 55px;
          color: #828792;
          float: left;
        }
        .txt{
          width: 160px;
          float: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.follow-list-ul{
  padding: 0;
  margin: 0;
  list-style: none;
  .follow-item{
    width: 100%;
    position: relative;
    margin-bottom: 30px;
    &:last-child{
      margin-bottom: 0;
    }
    .user-info{
      width: 100%;
      position: relative;
      padding-left: 50px;
      .photo{
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
      }
      .name{
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 2px;
        cursor: pointer;
        span{
          font-size: 12px;
          margin-left: 10px;
        }
      }
      .time{
        font-size: 12px;
        color:#999;
      }
    }
    .follow-content{
      padding-top: 10px;
      font-size: 13px;
      width: 100%;
    }
    .follow-imgs{
      width: 100%;
      position: relative;
      margin-top: 10px;
      .follow-img{
        width:50px;
        height: 50px;
        margin-right: 10px;
        border:1px dashed #f5f7fa;
      }
    }
    .client-info{
      margin-top: 5px;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      padding: 5px 10px;
      font-size: 12px;
      color: #9aaabf;
      cursor: pointer;
    }
  }
}
.project-info{
  .info-box{
    width: 100%;
    position: relative;
    padding-left: 90px;
    padding-top: 10px;
    margin-bottom: 30px;
    .percent{
      position: absolute;
      left: 0;
      top: 0;
    }
    .name{
      font-size: 16px;
      color: #262626;
    }
    .time{
      font-size: 14px;
      margin-top: 10px;
      color: #8c8c8c;
    }
  }
  .info{
    width: 100%;
    position: relative;
    padding-left: 90px;
    font-size: 14px;
    margin-top: 14px;
    .tit{
      width: 120px;
      position: absolute;
      left: 0;
      top: 0;
      color: #8c8c8c;
      i{
        margin-right: 8px;
      }
    }
    .txt{
      width: 100%;
      position: relative;
      color: #262626;
    }
  }
  .overview-box{
    width: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    .overview-item{
      border: 1px solid #ffffff;
      cursor: pointer;
      height: 110px;
      margin: 0px 16px 16px 0;
      padding: 12px;
      width: 124px;
      span{
        color: rgb(140, 140, 140);
        font-size: 12px;
        white-space: nowrap;
      }
      .num{
        color: #262626;
        margin: 4px 0;
        font-weight: bold;
        font-size: 32px;
      }
      .el-progress-bar {
        padding-right: 0;
      }
      &:hover{
        .num{
          color: #409EFF;
        }
      }
    }
    .active{
      border: 1px solid rgb(229, 229, 229);
      border-radius: 4px
    }
  }
}
</style>
